import { useContext, useEffect, useState } from 'react';
import { EntryContext } from '../contexts/entryContext';
import API from '../API';

const useTSReporting = (revealGame) => {
    const { entry } = useContext(EntryContext);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [completed, setCompleted] = useState(false);
    const [error, setError] = useState(false);

    const ticketNumber = entry?.TicketDetails?.TicketData;
    const gameId = entry?.TicketDetails?.GameId;
    const revealGameId = revealGame?.game_id;
    const revealGameName = revealGame?.name;

    useEffect(() => {
        const fetchGameUrl = async () => {
            const payload = {
                ticket_number: ticketNumber,
                reveal_game_id: revealGameId,
                reveal_game_name: revealGameName,
                game_id: `${gameId}`,
            };

            if (!ticketNumber || !revealGameId || !revealGameName || !gameId) {
                setLoading(false);
                console.error('🔴 Incomplete data for reveal game.', payload);
                setError({ message: 'Incomplete payload data.', payload });
                return;
            }

            try {
                setLoading(true);
                const response = await API.post('feed/revealgame', payload);
                //? For debug: console.log('🔵 API response from feed/revealgame:', JSON.stringify(response?.data || {}), response);
                setSuccess(response);
                setError(false);
            } catch (error) {
                console.error('🔴 API when hitting api/feed/revealgame', error);
                setError(error);
            } finally {
                setCompleted(true);
                setLoading(false);
            }
        };

        if (revealGameId) {
            fetchGameUrl();
        }
    }, [ticketNumber, revealGameId, revealGameName, gameId]);

    return { success, error, loading, completed };
};

export default useTSReporting;
